export const request = {
  javascript: [
    `curl --location --request POST 'https://partner.tst.auws.cloud/v1/auth/signup' 
--header 'Content-Type: application/json' 
--header 'X-AU-Key: XXXX' 
--header 'X-AU-Token: XXXX' 
--data-raw {
"email": "test@grr.la",
"password": "123123",
"locale": "en"
}`,
  ],

  shell: [
    `wget --no-check-certificate --quiet 
--method POST 
--timeout=0 
--header 'Content-Type: application/json' 
--header 'X-AU-Key: XXXX' 
--header 'X-AU-Token: XXXX' 
--body-data '{
"email": "test@grr.la",
"password": "Tt123123#",
"locale": "en"
}' 
'https://partner.tst.auws.cloud/v1/auth/signup'`,
  ],

  ruby: [
    `require "uri"
require "json"
require "net/http"

url = URI("https://partner.tst.auws.cloud/v1/auth/signup")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::Post.new(url)
request["Content-Type"] = "application/json"
request["X-AU-Key"] = "XXXX"
request["X-AU-Token"] = "XXXX"
request.body = JSON.dump({
"email": "test@grr.la",
"password": "Tt123#123",
"locale": "en"
})

response = https.request(request)
puts response.read_body`,
  ],

  python: [
    `import http.client
import json

conn = http.client.HTTPSConnection("partner.tst.auws.cloud")
payload = json.dumps({
"email": "test@grr.la",
"password": "123123",
"locale": "en"
})
headers = {
'Content-Type': 'application/json',
'X-AU-Key': 'XXXX',
'X-AU-Token': 'XXXX'
}
conn.request("POST", "/v1/auth/signup", payload, headers)
res = conn.getresponse()
data = res.read()
print(data.decode("utf-8"))`,
  ],
};

export const response = {
  success: [
    `{
  "status": "success",
  "data": {},
  "error": {},
  "message": "User created"
}`,
  ],
  error: [
    `{
  "status": "fail",
  "data": null,
  "error": {},
  "message": "Email already exists"
}`,

    `{
  "status": "fail",
  "data": null,
  "error": {},
  "message": "Password should not be blank"
}`,
  ],
};
